/* ============================================================
   ARTLEAP — 保存した作品（2026-09-23）
   ・作品カードと作品ページに♡。押すとブラウザに残る（localStorage）。
   ・ヘッダーに件数。/pages/saved で一覧できる。
   ・ログイン不要。プライベートウィンドウなど保存できない環境では
     ♡ごと出さない（押しても消える体験をさせない）。
   ============================================================ */
(function () {
  'use strict';
  /* 画面の文言：layout/theme.liquid → snippets/i18n-js が window.__i18n.saved に言語ごとの文言を入れる。無ければ日本語の既定（2026-10-25） */
  var I18N = (window.__i18n && window.__i18n.saved) || {};
  function T(k, d) { var v = I18N[k]; return (v == null || v === '') ? d : v; }

  var KEY = 'ah:saved';
  var MAX = 200;

  /* 保存できる環境かどうか。できないなら何もしない */
  var ok = (function () {
    try {
      window.localStorage.setItem('ah:test', '1');
      window.localStorage.removeItem('ah:test');
      return true;
    } catch (e) { return false; }
  })();
  if (!ok) return;

  function read() {
    try {
      var raw = window.localStorage.getItem(KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Object.prototype.toString.call(list) === '[object Array]' ? list : [];
    } catch (e) { return []; }
  }
  function write(list) {
    try { window.localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX))); } catch (e) { /* 容量超過などは黙って諦める */ }
  }
  function has(handle) { return read().indexOf(handle) > -1; }
  function toggle(handle) {
    var list = read();
    var i = list.indexOf(handle);
    if (i > -1) { list.splice(i, 1); } else { list.unshift(handle); }
    write(list);
    paint();
    return i === -1;
  }

  /* ---------- ヘッダーの件数 ---------- */
  function paint() {
    var n = read().length;
    var box = document.querySelector('[data-saved-count]');
    if (box) {
      box.hidden = n === 0;
      var b = box.querySelector('b');
      if (b) { b.textContent = n > 99 ? '99+' : String(n); }
    }
    var btns = document.querySelectorAll('[data-save]');
    for (var i = 0; i < btns.length; i++) {
      var on = has(btns[i].getAttribute('data-save'));
      btns[i].classList.toggle('is-on', on);
      btns[i].setAttribute('aria-pressed', on ? 'true' : 'false');
      var lbl = btns[i].querySelector('[data-save-label]');
      if (lbl) { lbl.textContent = on ? T('saved', '保存済み') : T('save', '保存する'); }
      btns[i].setAttribute('aria-label', on ? T('unsave', '保存を外す') : T('save', '保存する'));
    }
  }

  /* ---------- カードに♡を足す ---------- */
  function decorate() {
    var cards = document.querySelectorAll('.wcard[data-handle]');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (card.querySelector('.wcard__save')) continue;
      var art = card.querySelector('.wcard__art') || card;
      var handle = card.getAttribute('data-handle');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'wcard__save';
      btn.setAttribute('data-save', handle);
      btn.setAttribute('aria-pressed', 'false');
      btn.innerHTML = '<i class="ti ti-heart" aria-hidden="true"></i>';
      art.appendChild(btn);
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-save]') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    toggle(btn.getAttribute('data-save'));
  });

  decorate();
  paint();

  /* ---------- 保存した作品ページ ---------- */
  var page = document.querySelector('[data-saved-page]');
  if (!page) return;

  var grid  = page.querySelector('[data-saved-grid]');
  var empty = page.querySelector('[data-saved-empty]');
  var tools = page.querySelector('[data-saved-tools]');
  var clear = page.querySelector('[data-saved-clear]');

  function yen(cents) { return '¥' + Math.round(cents / 100).toLocaleString('ja-JP'); }

  function card(p) {
    var wrap = document.createElement('div');
    wrap.className = 'scard';

    var a = document.createElement('a');
    a.href = p.url;

    var media = document.createElement('div');
    media.className = 'scard__media';
    if (p.featured_image) {
      /* /products/*.js の画像URLは「//cdn.shopify.com/…?v=…」の形。
         プロトコルを足して、幅だけ指定する（_600x の旧記法は /files/ では効かない） */
      var src = p.featured_image;
      if (src.indexOf('//') === 0) { src = 'https:' + src; }
      src += (src.indexOf('?') > -1 ? '&' : '?') + 'width=600';
      var img = document.createElement('img');
      img.src = src;
      img.alt = p.title;
      img.loading = 'lazy';
      media.appendChild(img);
    }
    a.appendChild(media);

    var cap = document.createElement('div');
    cap.className = 'scard__cap';
    var ar = document.createElement('div');
    ar.className = 'scard__artist';
    ar.textContent = p.vendor || '';
    cap.appendChild(ar);
    var ti = document.createElement('div');
    ti.className = 'scard__title';
    ti.textContent = p.title;
    cap.appendChild(ti);
    var pr = document.createElement('div');
    pr.className = 'scard__price';
    pr.textContent = p.available ? yen(p.price) : ((p.tags || []).indexOf('upcoming') > -1 ? T('upcoming_prefix', '販売前・') + yen(p.price) : T('sold_or_ended', 'SOLD / 販売終了'));
    cap.appendChild(pr);
    a.appendChild(cap);
    wrap.appendChild(a);

    var x = document.createElement('button');
    x.type = 'button';
    x.className = 'scard__x';
    x.setAttribute('aria-label', T('remove_from_saved', '保存から外す'));
    x.innerHTML = '<i class="ti ti-x" aria-hidden="true"></i>';
    x.addEventListener('click', function () {
      toggle(p.handle);
      wrap.remove();
      if (!grid.children.length) { showEmpty(); }
    });
    wrap.appendChild(x);
    return wrap;
  }

  function showEmpty() {
    if (empty) { empty.hidden = false; }
    if (tools) { tools.hidden = true; }
  }

  var handles = read();
  if (!handles.length) { showEmpty(); return; }
  if (empty) { empty.hidden = true; }
  if (tools) { tools.hidden = false; }

  handles.forEach(function (h) {
    fetch('/products/' + encodeURIComponent(h) + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p) return;
        p.handle = h;
        grid.appendChild(card(p));
      })
      .catch(function () { /* 消えた商品は黙って飛ばす */ });
  });

  if (clear) {
    clear.addEventListener('click', function () {
      write([]);
      grid.textContent = '';
      showEmpty();
      paint();
    });
  }
})();
